import * as styles from '@components/iconButton/IconButton.styles';
import { Theme } from '@mui/material';
import { adjustFontSize } from '@theme/styleOverrides/typography';

export const staticInputLabelStyles = ({ palette }: Theme) =>
  ({
    '&.MuiFormLabel-root.MuiInputLabel-root': {
      fontSize: `${adjustFontSize(12, palette.fontSize)}px`,
      margin: '0 0 2px 0',
    },
  }) as const;

export const textFieldStyles = (theme: Theme) =>
  ({
    '& .MuiOutlinedInput-root': {
      borderRadius: (theme: Theme) => theme.shape.borderRadius,
      '& .MuiInputAdornment-root': {
        color: theme.palette.text.subdued,
        '.MuiIcon-root': {
          ...theme.icons.sm,
          color: theme.palette.text.subdued,
          '& svg': { ...theme.icons.xs },
        },
      },

      '& .MuiAutocomplete-endAdornment': {
        '& .MuiAutocomplete-clearIndicator': {
          // x icon
          ...styles.circularDarkStyle,
          color: theme.palette.text.subdued,
          width: '28px',
          height: '28px',
          marginRight: '-10px',
          visibility: 'hidden',
        },
        '& .MuiAutocomplete-popupIndicator': {
          ...styles.circularDarkStyle,
          color: theme.palette.text.subdued,
          width: '28px',
          height: '28px',
        },
      },
      fieldset: {
        borderWidth: '1px',
        borderColor: theme.palette.text.subdued,
      },
      '&:hover': {
        '& > fieldset': {
          borderColor: theme.palette.text.subdued,
        },
      },
      '&.Mui-focused': {
        '& > fieldset': {
          borderWidth: '2px',
          borderColor: theme.palette.secondary.main,
        },
      },
      '&.Mui-error': {
        '& > fieldset': {
          borderColor: theme.palette.error.main,
        },
      },
      '&.Mui-disabled': {
        '& > fieldset': {
          borderColor: theme.palette.text.disabled,
        },
      },
      input: {
        color: theme.palette.text.main,
        '&.Mui-disabled': {
          WebkitTextFillColor: theme.palette.text.disabled,
          opacity: 'unset',
        },
        '&::placeholder': {
          fontSize: ({ palette }: Theme) => `${adjustFontSize(14, palette.fontSize)}px`,
          color: theme.palette.text.subdued,
        },
      },
      textarea: {
        color: theme.palette.text.main,
      },
      '& .MuiIconButton-root': {
        margin: 0,
        '&.Mui-disabled': {
          color: theme.palette.text.disabled,
        },
      },
      '. &MuiInputAdornment-root': {
        width: '28px',
        height: '28px',
      },
    },
  }) as const;
